import __request__ from 'routing/request';
type PipelineSourceArray = PipelineSource[];
interface Object {
}
interface ParseError {
    readonly line: number;
    readonly position_in_line: number;
    readonly type: string;
}
interface PaginatedResponse {
    readonly [_key: string]: Object;
}
interface PipelineSource {
    readonly stages: StageSource[];
    readonly description: string;
    readonly created_at: string;
    readonly id: string;
    readonly source: string;
    readonly title: string;
    readonly modified_at: string;
    readonly errors: ParseError[];
}
interface StageSource {
    readonly stage: number;
    readonly match: 'ALL' | 'EITHER' | 'PASS';
    readonly rules: string[];
}
/**
 * Create a processing pipeline from source
 */
export function createFromParser(pipeline: PipelineSource): Promise<PipelineSource> {
    return __request__('POST', '/system/pipelines/pipeline', pipeline, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get all processing pipelines
 */
export function getAll(): Promise<PipelineSourceArray> {
    return __request__('GET', '/system/pipelines/pipeline', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a paginated list of pipelines
 * @param sort The field to sort the result on
 * @param order The sort direction
 */
export function getPage(sort: 'title' | 'description' | 'id' = 'title', page: number = 1, per_page: number = 50, query?: string, order: 'asc' | ' desc' = 'asc'): Promise<PaginatedResponse> {
    return __request__('GET', '/system/pipelines/pipeline/paginated', null, { 'page': page, 'per_page': per_page, 'query': query, 'sort': sort, 'order': order }, {
        'Accept': ['application/json']
    });
}
/**
 * Parse a processing pipeline without saving it
 */
export function parse(pipeline: PipelineSource): Promise<PipelineSource> {
    return __request__('POST', '/system/pipelines/pipeline/parse', pipeline, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a processing pipeline
 */
export function get(id?: string): Promise<PipelineSource> {
    return __request__('GET', `/system/pipelines/pipeline/${id}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Modify a processing pipeline
 */
export function update(pipeline: PipelineSource, id?: string): Promise<PipelineSource> {
    return __request__('PUT', `/system/pipelines/pipeline/${id}`, pipeline, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete a processing pipeline
 */
export function remove(id?: string): Promise<void> {
    return __request__('DELETE', `/system/pipelines/pipeline/${id}`, null, {}, {
        'Accept': ['application/json']
    });
}
